import IconButton from '@mui/material/IconButton';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Dispatch, SetStateAction } from 'react';
import { CheckoutUserFlowEnum } from 'components/views/pages/Checkout/types';

interface Props {
  children: React.ReactNode;
  setCheckoutUserFlowStep: Dispatch<SetStateAction<CheckoutUserFlowEnum>>;
  title: string;
  isOpen: boolean;
  close: () => void;
  backAction?: CheckoutUserFlowEnum;
}

export const CheckoutUserFlowDialog = ({
  children,
  title,
  isOpen,
  backAction,
  close,
  setCheckoutUserFlowStep,
}: Props) => {
  return (
    <ConfirmationDialog
      dialogTitle={title}
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      disableBackdropClick={true}
      hasBottomBar={false}
      maxWidth="xs"
      LeftHeaderComponent={
        <IconButton
          disabled={!backAction}
          onClick={() => backAction && setCheckoutUserFlowStep(backAction)}
          size="large"
        >
          <ArrowBackIosNewIcon sx={{ visibility: backAction ? 'visible' : 'hidden' }} fontSize={'small'} />
        </IconButton>
      }
    >
      {children}
    </ConfirmationDialog>
  );
};
